import { UseQueryOptions, useQuery } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiParams } from "../../api-client/types"
import { TApiGenericError, TApiGenericResponse } from "../../timenotes-query/timenotes-query.types"
import { TApiInvitation } from "../../api-client/invitations-api"

interface Params extends TApiParams {}

interface Result {
  invitations: TApiInvitation[]
}

export const useInvitationsListQuery = (params?: Params, options?: UseQueryOptions<any, any>) => {
  const apiClient = useApiClient()

  const query = useQuery<Result, TApiGenericError<any>>(
    ['invitations', (params || {})] as const,
    async () => {
      const response = await apiClient.getInvitations(params)

      if (!response.ok) {
        throw response.errors || {}
      }

      return {
        invitations: response.invitations || []
      }
    },
    {
      ...options
    }
  )

  return {
    query
  }
}